module.exports = __webpack_public_path__ + "static/teleco_23-533987aed054d366ca440dac812066d4.jpg";